import { render } from "./Colors.vue?vue&type=template&id=0dbe914e&scoped=true"
import script from "./Colors.vue?vue&type=script&lang=js"
export * from "./Colors.vue?vue&type=script&lang=js"

import "./Colors.vue?vue&type=style&index=0&id=0dbe914e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbe914e"]])

export default __exports__